/**
 * Ace Relocations: map total inventory CFT to a suggested truck class.
 * Kept in sync with backend/utils/suggestedTruckFromCft.js
 */
export function suggestTruckFromCft(totalCft) {
  const c = Number(totalCft);
  if (!Number.isFinite(c) || c <= 0) {
    return { label: "", loadDescription: "" };
  }

  if (c <= 120) {
    return { label: "7 ft", loadDescription: "7 Ft Load" };
  }
  if (c <= 170) {
    return { label: "8 ft", loadDescription: "8 Ft Load" };
  }
  if (c <= 250) {
    return { label: "9 ft", loadDescription: "9 Ft Load" };
  }
  if (c <= 430) {
    return { label: "14 ft", loadDescription: "14 Ft Load" };
  }
  if (c <= 520) {
    return { label: "17 ft", loadDescription: "17 Ft Load" };
  }
  if (c <= 790) {
    return { label: "19 ft", loadDescription: "19 Ft Load" };
  }
  if (c <= 940) {
    return {
      label: "20–22 ft open-body",
      loadDescription: "20–22 Ft Open-body Load",
    };
  }
  return {
    label: "22–24 ft truck/container (route & access)",
    loadDescription: "22–24 Ft Load (confirm per route & access)",
  };
}
